import { render, staticRenderFns } from "./BrandProductModal.vue?vue&type=template&id=6c225bdd&lang=pug"
import script from "./BrandProductModal.vue?vue&type=script&lang=js"
export * from "./BrandProductModal.vue?vue&type=script&lang=js"
import style0 from "./BrandProductModal.vue?vue&type=style&index=0&id=6c225bdd&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports